import { SessionIdSchema } from '@shared/modelTypes/session-types';
import { z } from 'zod';

export const LocationIdSchema = z.uuid();
export type LocationId = z.infer<typeof LocationIdSchema>;

export const LocationCodeSchema = z.string().min(3).max(10);
export type LocationCode = z.infer<typeof LocationCodeSchema>;

export const LocationNameSchema = z.string().min(1).max(255);
export type LocationName = z.infer<typeof LocationNameSchema>;

export const LocationSchema = z.object({
	id: LocationIdSchema,
	name: LocationNameSchema,
	code: LocationCodeSchema,
	sessionId: z.uuid().nullable(),
});
export type Location = z.infer<typeof LocationSchema>;

export const SessionListSchema = z.object({
	id: SessionIdSchema,
	createdAt: z.date(),
});
export type SessionList = z.infer<typeof SessionListSchema>;

export const LocationWithSessionsSchema = z.object({
	id: LocationIdSchema,
	name: LocationNameSchema,
	code: LocationCodeSchema,
	sessionId: z.uuid().nullable(),
	sessions: z.array(SessionListSchema),
});
export type LocationWithSessions = z.infer<typeof LocationWithSessionsSchema>;

export const SetLocationSchema = z.object({
	code: LocationCodeSchema,
	deviceId: z.uuid(),
});
export type SetLocation = z.infer<typeof SetLocationSchema>;

export const LocationCreateSchema = LocationSchema.omit({ id: true, sessionId: true });
export type LocationCreate = z.infer<typeof LocationCreateSchema>;

export const LocationUpdateSchema = LocationSchema.omit({ sessionId: true });
export type LocationUpdate = z.infer<typeof LocationUpdateSchema>;
